
<div class="container-fluid">
      
    <div class="pageheader d-flex align-items-center justify-content-between mb-2">
      <h4 class="d-flex align-items-center mb-1">
            New Case
        </h4>
    </div>

    <app-card>
    <form [formGroup]="newCaseDetails" autocomplete="off">

      <!-- Case Type -->
      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Case Type</label>
          <select class="form-select" [class.is-invalid]="isInvalid('typeId')" formControlName="typeId">
            <option *ngFor="let type of caseTypes" [value]="type.id">{{type.caseTypeName}}</option>
          </select>
          <div class="invalid-feedback">Case type is required</div>
        </div>
         <div class="col-sm-6" *ngIf="newCaseDetails.controls['typeId'].value == 0">
          <label class="form-label fw-semibold">Other Case Type <span class="text-danger">*</span></label>
          <input class="form-control" [class.is-invalid]="isInvalid('typeOther')" maxlength="100" formControlName="typeOther">
          <div class="invalid-feedback">Please specify the case type</div>
        </div>
      </div>

      <!-- Client One -->
      <h5 class="border-bottom pb-2 mb-3">Client One</h5>

      <div class="row mb-3">
        <div class="col-sm-3">
          <label class="form-label fw-semibold">Title <span class="text-danger">*</span></label>
          <select class="form-select" [class.is-invalid]="isInvalid('partyOneTitleId')" formControlName="partyOneTitleId">
            <option [value]="0"></option>
            <option *ngFor="let title of titles" [value]="title.id">{{title.titleName}}</option>
          </select>
          <div class="invalid-feedback">Title is required</div>
        </div>
        <div class="col-sm-3">
          <label class="form-label fw-semibold">First Name <span class="text-danger">*</span></label>
          <input class="form-control" [class.is-invalid]="isInvalid('partyOneFirstName')" maxlength="25" formControlName="partyOneFirstName">
          <div class="invalid-feedback">First name is required</div>
        </div>
        <div class="col-sm-3">
          <label class="form-label fw-semibold">Middle Name(s)</label>
          <input class="form-control" maxlength="50" formControlName="partyOneMiddleNames">
        </div>
        <div class="col-sm-3">
          <label class="form-label fw-semibold">Last Name <span class="text-danger">*</span></label>
          <input class="form-control" [class.is-invalid]="isInvalid('partyOneLastName')" maxlength="25" formControlName="partyOneLastName">
          <div class="invalid-feedback">Last name is required</div>
        </div>
      </div>

      <h6 class="mb-3">Correspondence Address</h6>

      <div class="row mb-3">
        <div class="col-sm-3">
          <label class="form-label fw-semibold">Postcode <span class="text-danger">*</span></label>
          <div class="input-group">
            <input class="form-control" [class.is-invalid]="isInvalid('partyOnePostcode')" maxlength="10" formControlName="partyOnePostcode" #partyOnePostcode>
            <app-address-lookup-button [for]="addressLookup1"></app-address-lookup-button>
            <div class="invalid-feedback">A valid postcode is required</div>
          </div>
        </div>
      </div>

      <app-address-lookup #addressLookup1 lookupType="postcode" [searchField]="partyOnePostcode"
        [add1]="newCaseDetails.controls['partyOneAddressLine1']"
        [add2]="newCaseDetails.controls['partyOneAddressLine2']"
        [add3]="newCaseDetails.controls['partyOneAddressLine3']"
        [add4]="newCaseDetails.controls['partyOneAddressLine4']"
        [add5]="newCaseDetails.controls['partyOneAddressLine5']"
        [addPc]="newCaseDetails.controls['partyOnePostcode']">
      </app-address-lookup>

      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Address Line 1 <span class="text-danger">*</span></label>
          <input class="form-control" [class.is-invalid]="isInvalid('partyOneAddressLine1')" maxlength="100" formControlName="partyOneAddressLine1">
          <div class="invalid-feedback">Address line 1 is required</div>
        </div>
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Address Line 2</label>
          <input class="form-control" maxlength="100" formControlName="partyOneAddressLine2">
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Address Line 3</label>
          <input class="form-control" maxlength="100" formControlName="partyOneAddressLine3">
        </div>
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Address Line 4</label>
          <input class="form-control" maxlength="100" formControlName="partyOneAddressLine4">
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Address Line 5</label>
          <input class="form-control" maxlength="100" formControlName="partyOneAddressLine5">
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-sm-3">
          <label class="form-label fw-semibold">Contact Number 1 <span class="text-danger">*</span></label>
          <input class="form-control" [class.is-invalid]="isInvalid('partyOneContactNumberOne')" maxlength="15" formControlName="partyOneContactNumberOne">
          <div class="invalid-feedback">Contact number is required</div>
        </div>
        <div class="col-sm-3">
          <label class="form-label fw-semibold">Contact Number 2</label>
          <input class="form-control" maxlength="15" formControlName="partyOneContactNumberTwo">
        </div>
        <div class="col-sm-3">
          <label class="form-label fw-semibold">Date of Birth</label>
          <input type="date" class="form-control" formControlName="partyOneDateOfBirth">
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-sm-4">
          <label class="form-label fw-semibold">Happy to receive updates by Text?</label>
          <app-yes-no-form-toggle class="d-block" formControlName="partyOneCorrespondenceSMS"></app-yes-no-form-toggle>
        </div>
         <div class="col-sm-4">
          <label class="form-label fw-semibold">Has Email Address? <span class="text-danger">*</span></label>
          <app-yes-no-form-toggle class="d-block" [class.is-invalid]="isInvalid('partyOneHasEmailAddress')" formControlName="partyOneHasEmailAddress"></app-yes-no-form-toggle>
          <div class="text-danger small mt-1" *ngIf="isInvalid('partyOneHasEmailAddress')">This field is required</div>
        </div>
        <div class="col-sm-4" *ngIf="newCaseDetails.controls['partyOneHasEmailAddress'].value == true">
          <label class="form-label fw-semibold">Email Address <span class="text-danger">*</span></label>
          <input class="form-control" [class.is-invalid]="isInvalid('partyOneEmailAddress')" maxlength="50" formControlName="partyOneEmailAddress">
          <div class="invalid-feedback">Email address is required</div>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-sm-4" *ngIf="newCaseDetails.controls['partyOneHasEmailAddress'].value == 1">
          <label class="form-label fw-semibold">Receive Correspondence by Email?</label>
          <app-yes-no-form-toggle class="d-block" formControlName="partyOneCorrespondenceEmail" (change)="correspondenceCheck('email')"></app-yes-no-form-toggle>
        </div>
        <div class="col-sm-4">
          <label class="form-label fw-semibold">Receive Correspondence by Letter?</label>
          <app-yes-no-form-toggle class="d-block" formControlName="partyOneCorrespondenceLetter" (change)="correspondenceCheck('letter')"></app-yes-no-form-toggle>
        </div>
      </div>

      <!-- Client Two -->
      <h5 class="border-bottom pb-2 mb-3 mt-4">Client Two</h5>

      <div class="row mb-3">
        <div class="col-sm-3">
          <label class="form-label fw-semibold">Title</label>
          <select class="form-select" formControlName="partyTwoTitleId">
            <option [value]="0"></option>
            <option *ngFor="let title of titles" [value]="title.id">{{title.titleName}}</option>
          </select>
        </div>
        <div class="col-sm-3">
          <label class="form-label fw-semibold">First Name</label>
          <input class="form-control" maxlength="25" formControlName="partyTwoFirstName">
        </div>
        <div class="col-sm-3">
          <label class="form-label fw-semibold">Middle Name(s)</label>
          <input class="form-control" maxlength="50" formControlName="partyTwoMiddleNames">
        </div>
        <div class="col-sm-3">
          <label class="form-label fw-semibold">Last Name</label>
          <input class="form-control" maxlength="25" formControlName="partyTwoLastName">
        </div>
      </div>

      <div class="d-flex justify-content-end mb-3">
        <button type="button" class="btn btn-outline-success" (click)="copyAddress()">
          Copy Address From Client One
        </button>
      </div>

      <h6 class="mb-3">Correspondence Address</h6>

      <div class="row mb-3">
        <div class="col-sm-3">
          <label class="form-label fw-semibold">Postcode</label>
          <div class="input-group">
            <input class="form-control" maxlength="10" formControlName="partyTwoPostcode" #partyTwoPostcode>
            <app-address-lookup-button [for]="addressLookup2"></app-address-lookup-button>
          </div>
        </div>
      </div>

      <app-address-lookup #addressLookup2 lookupType="postcode" [searchField]="partyTwoPostcode"
        [add1]="newCaseDetails.controls['partyTwoAddressLine1']"
        [add2]="newCaseDetails.controls['partyTwoAddressLine2']"
        [add3]="newCaseDetails.controls['partyTwoAddressLine3']"
        [add4]="newCaseDetails.controls['partyTwoAddressLine4']"
        [add5]="newCaseDetails.controls['partyTwoAddressLine5']"
        [addPc]="newCaseDetails.controls['partyTwoPostcode']">
      </app-address-lookup>

      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Address Line 1</label>
          <input class="form-control" maxlength="100" formControlName="partyTwoAddressLine1">
        </div>
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Address Line 2</label>
          <input class="form-control" maxlength="100" formControlName="partyTwoAddressLine2">
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Address Line 3</label>
          <input class="form-control" maxlength="100" formControlName="partyTwoAddressLine3">
        </div>
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Address Line 4</label>
          <input class="form-control" maxlength="100" formControlName="partyTwoAddressLine4">
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Address Line 5</label>
          <input class="form-control" maxlength="100" formControlName="partyTwoAddressLine5">
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-sm-3">
          <label class="form-label fw-semibold">Contact Number 1</label>
          <input class="form-control" maxlength="15" formControlName="partyTwoContactNumberOne">
        </div>
        <div class="col-sm-3">
          <label class="form-label fw-semibold">Contact Number 2</label>
          <input class="form-control" maxlength="15" formControlName="partyTwoContactNumberTwo">
        </div>
        <div class="col-sm-3">
          <label class="form-label fw-semibold">Date of Birth</label>
          <input type="date" class="form-control" formControlName="partyTwoDateOfBirth">
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-sm-4">
          <label class="form-label fw-semibold">Has Email Address?</label>
          <small class="text-muted d-block mb-1">Only press Yes if different from Client One</small>
          <app-yes-no-form-toggle class="d-block" formControlName="partyTwoHasEmailAddress"></app-yes-no-form-toggle>
        </div>
        <div class="col-sm-4" *ngIf="newCaseDetails.controls['partyTwoHasEmailAddress'].value == 1">
          <label class="form-label fw-semibold">Email Address</label>
          <input class="form-control" maxlength="50" formControlName="partyTwoEmailAddress">
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-sm-4" *ngIf="newCaseDetails.controls['partyTwoHasEmailAddress'].value == 1">
          <label class="form-label fw-semibold">Receive Correspondence by Email?</label>
          <app-yes-no-form-toggle class="d-block" formControlName="partyTwoCorrespondenceEmail"></app-yes-no-form-toggle>
        </div>
        <div class="col-sm-4">
          <label class="form-label fw-semibold">Receive Correspondence by Letter?</label>
          <app-yes-no-form-toggle class="d-block" formControlName="partyTwoCorrespondenceLetter"></app-yes-no-form-toggle>
        </div>
      </div>

    </form>

      <div class="d-flex justify-content-end mt-3">
        <button *ngIf="addingCase" type="button" class="btn btn-success" disabled>
          <span class="spinner-border spinner-border-sm" role="status"></span>
          Saving...
        </button>
        <button type="button" class="btn btn-success" *ngIf="!addingCase"
          [disabled]="newCaseDetails.invalid"
          (click)="createCase()">
          Create Case
        </button>
      </div>
 
       </app-card>
  </div>
 
